var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"pagination"},[_c('Pagination',{attrs:{"small":"","background":"","layout":"prev, pager, next","total":_vm.total,"page-size":_vm.per_page},on:{"current-change":_vm.update}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }